import { Bar } from "react-chartjs-2";

import ChartCard from "./ChartCard";

import {
  buildChartLabels,
  buildChartValues,
} from "../../../utils/admin/chartUtils";

import {
  CHART_COLORS,
} from "../../../constants/admin/chart/chartConstants";

const ChartPropertyStatus = ({ data }) => {
  const labels = buildChartLabels(
    data,
    "status"
  );

  const values = buildChartValues(data);

  return (
    <ChartCard title="Số lượng bất động sản theo trạng thái">
      <Bar
        data={{
          labels,

          datasets: [
            {
              label: "Số lượng BĐS",

              data: values,

              backgroundColor: [
                CHART_COLORS.primary,
                CHART_COLORS.danger,
                CHART_COLORS.warning,
              ],

              borderRadius: 6,

              maxBarThickness: 40,
            },
          ],
        }}
        options={{
          responsive: true,

          plugins: {
            legend: {
              position: "top",
            },
          },

          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                stepSize: 1,
              },
            },
          },
        }}
      />
    </ChartCard>
  );
};

export default ChartPropertyStatus;